module.exports = __webpack_public_path__ + "media/red-tailed-hawk-2.9394a2f1.mp3";